/**
 * This is a wrapper component for different Layouts. Main content should be added to this wrapper.
 */
import Box from '@mui/material/Box';
import React, { memo } from 'react';

/**
 * @param {object} props
 * @param {React.JSX.Element | React.JSX.Element[] | null} props.children
 * @param {import('@mui/material').SxProps} [props.sx={}]
 * @returns {React.JSX.Element}
 */
const LayoutWrapperMainComponent = ({ children, sx = {} }) => {
  return (
    <Box role="main" sx={{ height: '100%', ...sx }}>
      {children}
    </Box>
  );
};

LayoutWrapperMainComponent.displayName = 'LayoutWrapperMain';

const LayoutWrapperMain = memo(LayoutWrapperMainComponent);

export default LayoutWrapperMain;
